(() => {
  const MAX_CHARS = 100;
  const MAX_LINES = 3;
  const MIN_FONT = 10;
  const MAX_FONT = 36;
  const MIN_BOX_WIDTH = 18;
  const MAX_BOX_WIDTH = 100;
  const SNAP_THRESHOLD = 12;

  const SAFE_ZONE = { top: 18, left: 27, width: 46, height: 50 };
  const SAFE_ZONE_POLERON = { top: 17, left: 26, width: 48, height: 47 };

  const SWATCH_BY_COLOR = {
    Negro: '#111111',
    Blanco: '#ffffff',
    Rosa: '#f4a6b8',
  };

  const DEFAULT_TEXT_BY_COLOR = {
    Negro: 'blanco',
    Blanco: 'negro',
    Rosa: 'blanco',
  };

  const MOCKUP_CATALOG = {
    polera: [
      {
        id: 'ajustada-negra',
        prenda: 'Polera',
        corte: 'Ajustada',
        colorLabel: 'Negro',
        swatch: '#111111',
        image: 'mifelpa-polera-ajustada-negra.png',
        defaultTextColor: 'blanco',
      },
      {
        id: 'ajustada-blanca',
        prenda: 'Polera',
        corte: 'Ajustada',
        colorLabel: 'Blanco',
        swatch: '#ffffff',
        image: 'mifelpa-polera-ajustada-blanca.png',
        defaultTextColor: 'negro',
      },
      {
        id: 'ajustada-rosa',
        prenda: 'Polera',
        corte: 'Ajustada',
        colorLabel: 'Rosa',
        swatch: '#f4a6b8',
        image: 'mifelpa-polera-ajustada-rosa.png',
        defaultTextColor: 'blanco',
      },
      {
        id: 'unisex-rosa',
        prenda: 'Polera',
        corte: 'Unisex',
        colorLabel: 'Rosa',
        swatch: '#f4a6b8',
        image: 'mifelpa-polera-unisex-rosa.png',
        defaultTextColor: 'blanco',
      },
      {
        id: 'unisex-blanca',
        prenda: 'Polera',
        corte: 'Unisex',
        colorLabel: 'Blanco',
        swatch: '#ffffff',
        image: 'mifelpa-polera-unisex-blanca.png',
        defaultTextColor: 'negro',
      },
      {
        id: 'unisex-negra',
        prenda: 'Polera',
        corte: 'Unisex',
        colorLabel: 'Negro',
        swatch: '#111111',
        image: 'mifelpa-polera-unisex-negra.png',
        defaultTextColor: 'blanco',
      },
    ],
    poleron: [
      {
        id: 'gorro-rosa',
        prenda: 'Polerón',
        estilo: 'Con gorro',
        colorLabel: 'Rosa',
        swatch: '#f4a6b8',
        image: 'mifelpa-poleron-gorro-rosa.png',
        defaultTextColor: 'blanco',
      },
      {
        id: 'gorro-negra',
        prenda: 'Polerón',
        estilo: 'Con gorro',
        colorLabel: 'Negro',
        swatch: '#111111',
        image: 'mifelpa-poleron-gorro-negra.png',
        defaultTextColor: 'blanco',
      },
      {
        id: 'sin-gorro-rosa',
        prenda: 'Polerón',
        estilo: 'Sin gorro',
        colorLabel: 'Rosa',
        swatch: '#f4a6b8',
        image: 'mifelpa-poleron-sin-gorro-rosa.png',
        defaultTextColor: 'blanco',
      },
      {
        id: 'sin-gorro-negra',
        prenda: 'Polerón',
        estilo: 'Sin gorro',
        colorLabel: 'Negro',
        swatch: '#111111',
        image: 'mifelpa-poleron-sin-gorro-negra.png',
        defaultTextColor: 'blanco',
      },
    ],
  };

  const FONTS = [
    { id: 'cooper', label: 'Cooper Five' },
    { id: 'helvetica', label: 'Helvetica Bold' },
  ];

  const TEXT_COLORS = [
    { id: 'rojo', label: 'Rojo', value: '#D72626', swatch: '#D72626' },
    { id: 'negro', label: 'Negro', value: '#111111', swatch: '#111111' },
    { id: 'blanco', label: 'Blanco', value: '#FFFFFF', swatch: '#FFFFFF' },
  ];

  const ALIGNMENTS = [
    { id: 'left', label: 'Izquierda' },
    { id: 'center', label: 'Centrado' },
    { id: 'right', label: 'Derecha' },
    { id: 'justify', label: 'Justificado' },
  ];

  const ALIGN_ICONS = {
    left: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6h16M4 10h10M4 14h16M4 18h10" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    center: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6h16M7 10h10M5 14h14M8 18h8" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    right: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6h16M10 10h10M4 14h16M14 18h10" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    justify: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6h16M4 10h16M4 14h16M4 18h16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
  };

  const RESIZE_ICON =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14 14l6 6M16 14h4v4M10 10L4 4M8 10H4V6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

  const MOBILE_QUERY = '(max-width: 749px)';
  const DRAG_THRESHOLD = 6;
  const NUDGE_STEP = 2.5;
  const WIDTH_NUDGE_STEP = 4;
  const PROPERTY_FIELD_SELECTOR =
    '[data-hidden-text],[data-hidden-font],[data-hidden-prenda],[data-hidden-model],[data-hidden-color],[data-hidden-text-color],[data-hidden-align],[data-hidden-font-size],[data-hidden-position],[data-hidden-box-width],[data-preview-file]';
  const PREVIEW_PROPERTY_KEY = 'properties[Vista previa]';

  class MiFelpaPoloCustomizer extends HTMLElement {
    connectedCallback() {
      this.config = JSON.parse(this.dataset.config || '{}');
      this.garmentType = this.config.garmentType || 'polera';
      this.mockups = this.buildMockupsFromConfig();
      this.safeZoneConfig =
        this.config.safeZone || (this.garmentType === 'poleron' ? SAFE_ZONE_POLERON : SAFE_ZONE);
      this.optionNames =
        this.config.optionNames ||
        (this.garmentType === 'poleron' ? ['Estilo', 'Color', 'Talla'] : ['Corte', 'Color', 'Talla']);
      this.selectedStyle = this.garmentType === 'poleron' ? 'Con gorro' : 'Ajustada';
      this.selectedMockup =
        this.findMockup(this.selectedStyle, this.mockups[0]?.colorLabel) || this.mockups[0];
      this.selectedFont = FONTS[0].id;
      this.selectedTextColor = this.selectedMockup.defaultTextColor;
      this.selectedAlign = 'center';
      this.text = '';
      this.textColorTouched = false;
      this.fontSize = 18;
      this.boxLeft = 15;
      this.boxTop = 22;
      this.boxWidth = 70;
      this.dragState = null;
      this.isEditing = false;
      this.previewBlob = null;

      this.previewWrap = this.querySelector('[data-preview-wrap]');
      this.previewImage = this.querySelector('[data-preview-image]');
      this.safeZone = this.querySelector('[data-safe-zone]');
      this.textBox = this.querySelector('[data-text-box]');
      this.previewText = this.querySelector('[data-text-content]');
      this.dragHandle = this.querySelector('[data-drag-handle]');
      this.resizeHandle = this.querySelector('[data-resize-handle]');
      this.textInput = this.querySelector('[data-text-input]');
      this.counter = this.querySelector('[data-char-counter]');
      this.fontSizeInput = this.querySelector('[data-font-size]');
      this.fontSizeLabel = this.querySelector('[data-font-size-label]');
      this.colorOptions = this.querySelector('[data-color-options]');
      this.styleOptions = this.querySelector('[data-style-options]');
      this.styleLabel = this.querySelector('[data-style-label]');
      this.fontOptions = this.querySelector('[data-font-options]');
      this.textColorOptions = this.querySelector('[data-text-color-options]');
      this.alignOptions = this.querySelector('[data-align-options]');
      this.centerBtn = this.querySelector('[data-center-btn]');
      this.hiddenText = this.querySelector('[data-hidden-text]');
      this.hiddenFont = this.querySelector('[data-hidden-font]');
      this.hiddenPrenda = this.querySelector('[data-hidden-prenda]');
      this.hiddenModel = this.querySelector('[data-hidden-model]');
      this.hiddenColor = this.querySelector('[data-hidden-color]');
      this.hiddenTextColor = this.querySelector('[data-hidden-text-color]');
      this.hiddenAlign = this.querySelector('[data-hidden-align]');
      this.hiddenFontSize = this.querySelector('[data-hidden-font-size]');
      this.hiddenPosition = this.querySelector('[data-hidden-position]');
      this.hiddenBoxWidth = this.querySelector('[data-hidden-box-width]');
      this.purchaseSlot = this.querySelector('[data-purchase-slot]');
      this.previewFileInput = this.querySelector('[data-preview-file]');
      this.propertyFieldsHost = this.querySelector('[data-property-fields]');
      this.controlsPanel = this.querySelector('.mifelpa-customizer__controls-panel');
      this.mobilePosition = this.querySelector('[data-mobile-position]');

      if (this.resizeHandle) this.resizeHandle.innerHTML = RESIZE_ICON;
      if (this.previewText) {
        this.previewText.setAttribute('contenteditable', 'true');
        this.previewText.setAttribute('spellcheck', 'false');
        this.previewText.setAttribute('autocorrect', 'off');
        this.previewText.setAttribute('autocapitalize', 'characters');
        this.previewText.setAttribute('role', 'textbox');
        this.previewText.setAttribute('aria-multiline', 'true');
        this.previewText.setAttribute('aria-label', 'Texto en la prenda');
      }

      if (this.styleLabel) {
        this.styleLabel.textContent = this.garmentType === 'poleron' ? 'Estilo' : 'Corte';
      }

      this.applySafeZoneStyles();
      this.renderStyleOptions();
      this.renderColorOptions();
      this.renderFontOptions();
      this.renderTextColorOptions();
      this.renderAlignOptions();
      this.bindEvents();
      this.setupAddToCartIntercept();
      this.setupMobileControls();
      this.preloadFonts();
      this.centerTextBox();
      this.applyMockup(this.selectedMockup);
      this.updatePreview();
      requestAnimationFrame(() => this.centerTextBox());
      this.syncVariant();
      requestAnimationFrame(() => {
        this.setupPurchaseLayout();
        this.syncDesktopLayout();
        this.bindPropertyFieldsToForm();
        this.mountPropertyFieldsInForm();
      });
    }

    getProductForm() {
      if (this.productForm?.isConnected) return this.productForm;
      const section = this.closest('.shopify-section');
      this.productForm = section?.querySelector('[data-type="add-to-cart-form"]') || null;
      return this.productForm;
    }

    getPropertyFields() {
      return Array.from(this.querySelectorAll(PROPERTY_FIELD_SELECTOR));
    }

    bindPropertyFieldsToForm() {
      const form = this.getProductForm();
      if (!form?.id) return false;

      this.getPropertyFields().forEach((input) => {
        input.setAttribute('form', form.id);
      });
      return true;
    }

    mountPropertyFieldsInForm() {
      const form = this.getProductForm();
      if (!form || !this.propertyFieldsHost) return false;

      this.updatePreview();

      let mount = form.querySelector('[data-mifelpa-property-mount]');
      if (!mount) {
        mount = document.createElement('div');
        mount.dataset.mifelpaPropertyMount = '1';
        mount.hidden = true;
        form.appendChild(mount);
      }

      if (this.propertyFieldsHost.parentElement !== mount) {
        mount.appendChild(this.propertyFieldsHost);
      }

      form.enctype = 'multipart/form-data';
      form.encoding = 'multipart/form-data';

      this.getPropertyFields().forEach((input) => {
        input.removeAttribute('form');
      });

      if (this.previewBlob) {
        this.attachPreviewFile(this.previewBlob);
      }

      return true;
    }

    setupMobileControls() {
      if (!this.mobilePosition) return;

      this.mobileMedia = window.matchMedia(MOBILE_QUERY);
      const syncMobileUi = () => {
        const mobile = this.mobileMedia.matches;
        this.mobilePosition.hidden = !mobile;
        this.textBox?.classList.toggle('has-mobile-handle', mobile);
      };

      syncMobileUi();
      this.mobileMedia.addEventListener('change', syncMobileUi);
    }

    isMobileInteraction() {
      return window.matchMedia(MOBILE_QUERY).matches;
    }

    nudgeBox(direction) {
      const step = NUDGE_STEP;
      if (direction === 'up') this.boxTop -= step;
      if (direction === 'down') this.boxTop += step;
      if (direction === 'left') this.boxLeft -= step;
      if (direction === 'right') this.boxLeft += step;
      if (direction === 'wider') this.boxWidth += WIDTH_NUDGE_STEP;
      if (direction === 'narrower') this.boxWidth -= WIDTH_NUDGE_STEP;

      this.boxWidth = Math.min(Math.max(this.boxWidth, MIN_BOX_WIDTH), MAX_BOX_WIDTH);
      this.clampBoxPosition();
      this.updateTextBoxLayout();
      this.updateHiddenFields();
    }

    buildMockupsFromConfig() {
      const fromProduct = (this.config.mockups || []).filter((mockup) => mockup.imageUrl);
      if (fromProduct.length) {
        return fromProduct.map((mockup) => this.normalizeMockup(mockup));
      }
      return MOCKUP_CATALOG[this.garmentType] || MOCKUP_CATALOG.polera;
    }

    normalizeMockup(mockup) {
      const style = mockup.style || mockup.corte || mockup.estilo || '';
      const colorLabel = mockup.colorLabel || '';
      const catalogMatch =
        (MOCKUP_CATALOG[this.garmentType] || []).find(
          (item) => this.getStyleValue(item) === style && item.colorLabel === colorLabel
        ) || {};

      const normalized = {
        id: mockup.id || `${style}-${colorLabel}`.toLowerCase().replace(/\s+/g, '-'),
        prenda: mockup.prenda || catalogMatch.prenda || (this.garmentType === 'poleron' ? 'Polerón' : 'Polera'),
        colorLabel,
        imageUrl: mockup.imageUrl || '',
        image: mockup.imageUrl || catalogMatch.image || '',
        swatch: mockup.swatch || catalogMatch.swatch || SWATCH_BY_COLOR[colorLabel] || '#cccccc',
        defaultTextColor:
          mockup.defaultTextColor || catalogMatch.defaultTextColor || DEFAULT_TEXT_BY_COLOR[colorLabel] || 'negro',
        style,
      };

      if (this.garmentType === 'poleron') {
        normalized.estilo = style;
      } else {
        normalized.corte = style;
      }

      return normalized;
    }

    setupPurchaseLayout() {
      this.productDetails = this.closest('.product-details');
      if (!this.productDetails || !this.purchaseSlot) return;

      this.purchaseVariant = this.productDetails.querySelector('variant-picker');
      this.purchaseForm = this.productDetails.querySelector('product-form-component');
      this.headerGroup = this.productDetails.querySelector('.group-block-content > .group-block');
      this.headerDivider = this.productDetails.querySelector('.group-block-content > .divider');
      this.headerSlot = this.querySelector('[data-header-slot]');

      if (!this.desktopMedia) {
        this.desktopMedia = window.matchMedia('(min-width: 990px)');
        this.desktopMedia.addEventListener('change', () => this.syncDesktopLayout());
      }
    }

    syncDesktopLayout() {
      this.syncPurchaseLayout();
      this.syncHeaderLayout();
    }

    syncPurchaseLayout() {
      if (!this.purchaseSlot || !this.purchaseVariant || !this.purchaseForm) return;

      const desktop = this.desktopMedia?.matches ?? window.matchMedia('(min-width: 990px)').matches;

      if (desktop) {
        if (this.purchaseVariant.parentElement !== this.purchaseSlot) {
          this.purchaseSlot.appendChild(this.purchaseVariant);
        }
        if (this.purchaseForm.parentElement !== this.purchaseSlot) {
          this.purchaseSlot.appendChild(this.purchaseForm);
        }
      } else {
        if (this.purchaseVariant.parentElement === this.purchaseSlot) {
          this.insertAdjacentElement('afterend', this.purchaseVariant);
        }
        if (this.purchaseForm.parentElement === this.purchaseSlot) {
          this.purchaseVariant.insertAdjacentElement('afterend', this.purchaseForm);
        }
      }

      this.bindPropertyFieldsToForm();
      this.mountPropertyFieldsInForm();
      this.bindAddToCartButtons();
    }

    syncHeaderLayout() {
      if (!this.headerGroup || !this.headerSlot) return;

      const desktop = this.desktopMedia?.matches ?? window.matchMedia('(min-width: 990px)').matches;

      if (desktop) {
        if (this.headerGroup.parentElement !== this.headerSlot) {
          this.headerSlot.appendChild(this.headerGroup);
        }
        if (this.headerDivider) this.headerDivider.hidden = true;
        return;
      }

      if (this.headerGroup.parentElement === this.headerSlot) {
        this.insertAdjacentElement('beforebegin', this.headerGroup);
      }
      if (this.headerDivider) {
        this.headerDivider.hidden = false;
        if (this.headerDivider.previousElementSibling !== this.headerGroup) {
          this.headerGroup.insertAdjacentElement('afterend', this.headerDivider);
        }
      }
    }

    applySafeZoneStyles() {
      if (!this.safeZone) return;
      const zone = this.safeZoneConfig || SAFE_ZONE;
      this.safeZone.style.setProperty('--mf-safe-top', `${zone.top}%`);
      this.safeZone.style.setProperty('--mf-safe-left', `${zone.left}%`);
      this.safeZone.style.setProperty('--mf-safe-width', `${zone.width}%`);
      this.safeZone.style.setProperty('--mf-safe-height', `${zone.height}%`);
    }

    getStyleValue(mockup) {
      return mockup.estilo || mockup.corte || mockup.style || '';
    }

    findMockup(style, colorLabel) {
      return this.mockups.find((mockup) => {
        const styleMatch = this.getStyleValue(mockup) === style;
        const colorMatch = !colorLabel || mockup.colorLabel === colorLabel;
        return styleMatch && colorMatch;
      });
    }

    getAvailableStyles() {
      return [...new Set(this.mockups.map((mockup) => this.getStyleValue(mockup)))];
    }

    getMockupsForStyle(style) {
      return this.mockups.filter((mockup) => this.getStyleValue(mockup) === style);
    }

    renderStyleOptions() {
      if (!this.styleOptions) return;
      this.styleOptions.innerHTML = this.getAvailableStyles()
        .map(
          (style) => `
            <button type="button"
              class="mifelpa-customizer__option${style === this.selectedStyle ? ' is-active' : ''}"
              data-style-value="${style}"
            >${style}</button>
          `
        )
        .join('');
    }

    getSafeRect() {
      return this.safeZone?.getBoundingClientRect() || this.previewWrap?.getBoundingClientRect();
    }

    getBoxMetrics() {
      if (!this.textBox || !this.safeZone) {
        return {
          boxWidthPct: this.boxWidth,
          boxHeightPct: 22,
          centerX: this.boxLeft + this.boxWidth / 2,
          centerY: this.boxTop + 11,
          distX: Math.abs(this.boxLeft + this.boxWidth / 2 - 50),
          distY: Math.abs(this.boxTop + 11 - 50),
        };
      }

      const safeRect = this.safeZone.getBoundingClientRect();
      const boxRect = this.textBox.getBoundingClientRect();
      if (!safeRect.width || !safeRect.height) {
        return {
          boxWidthPct: this.boxWidth,
          boxHeightPct: 22,
          centerX: this.boxLeft + this.boxWidth / 2,
          centerY: this.boxTop + 11,
          distX: Math.abs(this.boxLeft + this.boxWidth / 2 - 50),
          distY: Math.abs(this.boxTop + 11 - 50),
        };
      }

      const boxWidthPct = (boxRect.width / safeRect.width) * 100;
      const boxHeightPct = (boxRect.height / safeRect.height) * 100;
      const centerX = ((boxRect.left + boxRect.width / 2 - safeRect.left) / safeRect.width) * 100;
      const centerY = ((boxRect.top + boxRect.height / 2 - safeRect.top) / safeRect.height) * 100;

      return {
        boxWidthPct,
        boxHeightPct,
        centerX,
        centerY,
        distX: Math.abs(centerX - 50),
        distY: Math.abs(centerY - 50),
      };
    }

    syncBoxWidthFromLayout() {
      const { boxWidthPct } = this.getBoxMetrics();
      this.boxWidth = Math.min(MAX_BOX_WIDTH, Math.max(MIN_BOX_WIDTH, boxWidthPct));
    }

    clampBoxPosition() {
      this.boxLeft = Math.min(Math.max(this.boxLeft, 0), 100 - this.boxWidth);
      if (this.dragState?.mode === 'drag') {
        this.boxTop = Math.min(Math.max(this.boxTop, 0), 90);
        return;
      }
      const { boxHeightPct } = this.getBoxMetrics();
      this.boxTop = Math.min(Math.max(this.boxTop, 0), Math.max(0, 100 - boxHeightPct));
    }

    centerTextBox() {
      this.updateTextBoxLayout();
      this.syncBoxWidthFromLayout();
      const { boxHeightPct } = this.getBoxMetrics();
      this.boxLeft = (100 - this.boxWidth) / 2;
      this.boxTop = Math.max(0, (100 - boxHeightPct) / 2);
      this.clampBoxPosition();
      this.updateTextBoxLayout();
    }

    applySnapToCenter(dragDelta = { x: 0, y: 0 }) {
      this.updateTextBoxLayout();
      this.syncBoxWidthFromLayout();
      const { boxHeightPct, distX, distY } = this.getBoxMetrics();
      const nearX = distX <= SNAP_THRESHOLD;
      const nearY = distY <= SNAP_THRESHOLD;
      let snapped = false;

      if (nearX || nearY) {
        const preferX =
          (nearX && !nearY) ||
          (nearX && nearY && (dragDelta.x > dragDelta.y || (dragDelta.x === dragDelta.y && distX <= distY)));

        if (preferX) {
          this.boxLeft = (100 - this.boxWidth) / 2;
          snapped = true;
        } else {
          this.boxTop = Math.max(0, (100 - boxHeightPct) / 2);
          snapped = true;
        }
      }

      if (snapped) {
        this.textBox?.classList.add('is-snapping');
        this.safeZone?.classList.add('is-snap-active');
        window.setTimeout(() => {
          this.textBox?.classList.remove('is-snapping');
          this.safeZone?.classList.remove('is-snap-active');
        }, 180);
      }

      this.clampBoxPosition();
      this.updateTextBoxLayout();
      this.updateHiddenFields();
    }

    updateSnapGuide() {
      if (!this.safeZone || this.dragState?.mode !== 'drag') {
        this.safeZone?.classList.remove('is-near-center-x', 'is-near-center-y');
        return;
      }

      const { distX, distY } = this.getBoxMetrics();
      const movedX = Math.abs(this.boxLeft - this.dragState.startLeft);
      const movedY = Math.abs(this.boxTop - this.dragState.startTop);
      const nearX = distX <= SNAP_THRESHOLD;
      const nearY = distY <= SNAP_THRESHOLD;

      this.safeZone.classList.toggle('is-near-center-x', nearX && movedX >= movedY);
      this.safeZone.classList.toggle('is-near-center-y', nearY && movedY > movedX);
    }

    updateTextBoxLayout() {
      if (!this.textBox) return;

      const zone = this.safeZoneConfig || SAFE_ZONE;
      const leftPct = zone.left + (this.boxLeft / 100) * zone.width;
      const topPct = zone.top + (this.boxTop / 100) * zone.height;
      const widthPct = (this.boxWidth / 100) * zone.width;

      this.textBox.style.left = `${leftPct}%`;
      this.textBox.style.top = `${topPct}%`;
      this.textBox.style.width = `${widthPct}%`;
    }

    renderColorOptions() {
      if (!this.colorOptions) return;
      const styleMockups = this.getMockupsForStyle(this.selectedStyle);
      this.colorOptions.innerHTML = styleMockups
        .map(
          (mockup) => `
            <button type="button"
              class="mifelpa-customizer__option mifelpa-customizer__option--swatch${mockup.colorLabel === 'Blanco' ? ' is-light' : ''}${mockup.id === this.selectedMockup.id ? ' is-active' : ''}"
              data-color-id="${mockup.id}"
              aria-label="${mockup.colorLabel}"
              title="${mockup.colorLabel}"
              style="background:${mockup.swatch}"
            ></button>
          `
        )
        .join('');
    }

    renderFontOptions() {
      if (!this.fontOptions) return;
      this.fontOptions.innerHTML = FONTS.map(
        (font) => `
          <button type="button" class="mifelpa-customizer__option${font.id === this.selectedFont ? ' is-active' : ''}" data-font-id="${font.id}">${font.label}</button>
        `
      ).join('');
    }

    renderTextColorOptions() {
      if (!this.textColorOptions) return;
      this.textColorOptions.innerHTML = TEXT_COLORS.map(
        (color) => `
          <button type="button"
            class="mifelpa-customizer__option mifelpa-customizer__option--swatch${color.id === 'blanco' ? ' is-light' : ''}${color.id === this.selectedTextColor ? ' is-active' : ''}"
            data-text-color-id="${color.id}"
            aria-label="${color.label}"
            title="${color.label}"
            style="background:${color.swatch}"
          ></button>
        `
      ).join('');
    }

    renderAlignOptions() {
      if (!this.alignOptions) return;
      this.alignOptions.innerHTML = ALIGNMENTS.map(
        (align) => `
          <button type="button"
            class="mifelpa-customizer__option mifelpa-customizer__option--align${align.id === this.selectedAlign ? ' is-active' : ''}"
            data-align-id="${align.id}"
            aria-label="${align.label}"
            title="${align.label}"
          >${ALIGN_ICONS[align.id]}</button>
        `
      ).join('');
    }

    async prepareAndSubmit(form) {
      if (this.isEditing) this.exitEditMode();
      this.normalizeTextInput();

      const textValue = this.text.trim();
      if (!textValue) {
        if (this.textInput) {
          this.textInput.focus();
          this.textInput.setCustomValidity('Escribe el texto que quieres imprimir.');
          this.textInput.reportValidity();
        } else {
          this.enterEditMode();
        }
        return;
      }

      if (this.textInput) this.textInput.setCustomValidity('');
      this.updatePreview();
      this.updateTextBoxLayout();
      this.mountPropertyFieldsInForm();

      try {
        this.previewBlob = await this.capturePreviewImage();
        this.attachPreviewFile(this.previewBlob);
      } catch (error) {
        console.error('MiFelpa: no se pudo generar la vista previa', error);
        this.previewBlob = null;
        if (this.previewFileInput) this.previewFileInput.value = '';
      }

      await this.submitToCart(form);
    }

    bindAddToCartButtons() {
      const section = this.closest('.shopify-section');
      const form = this.getProductForm();
      if (!section || !form) return;

      section.querySelectorAll('[name="add"]').forEach((button) => {
        if (button.dataset.mifelpaAtcBound === '1') return;
        button.dataset.mifelpaAtcBound = '1';
        button.removeAttribute('on:click');
        if (button.type === 'submit') button.type = 'button';

        button.addEventListener(
          'click',
          async (event) => {
            if (button.disabled) return;
            event.preventDefault();
            event.stopImmediatePropagation();
            await this.prepareAndSubmit(form);
          },
          true
        );
      });
    }

    setupAddToCartIntercept() {
      const section = this.closest('.shopify-section');
      const form = this.getProductForm();
      if (!section || !form) {
        requestAnimationFrame(() => this.setupAddToCartIntercept());
        return;
      }
      if (section.dataset.mifelpaAtcBound === '1') return;

      section.dataset.mifelpaAtcBound = '1';
      this.bindAddToCartButtons();

      if (!this.addButtonObserver) {
        this.addButtonObserver = new MutationObserver(() => this.bindAddToCartButtons());
        this.addButtonObserver.observe(section, { childList: true, subtree: true });
      }

      form.addEventListener(
        'submit',
        async (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          await this.prepareAndSubmit(form);
        },
        true
      );
    }

    showCartError(form, message) {
      const productFormComponent = form.closest('product-form-component');
      const errorEl = productFormComponent?.querySelector('[ref="addToCartTextError"]');
      if (errorEl) {
        errorEl.classList.remove('hidden');
        const textNode = errorEl.childNodes[2];
        if (textNode) textNode.textContent = message;
        else errorEl.appendChild(document.createTextNode(message));
        return;
      }
      window.alert(message);
    }

    async submitToCart(requestedForm) {
      // El tema vuelve a renderizar el formulario al cambiar de variante, así que el
      // que capturó el listener puede estar desconectado: se usa siempre el vivo.
      const form = this.getProductForm() || requestedForm;
      const productFormComponent = form.closest('product-form-component');
      const addToCartComponents = productFormComponent?.querySelectorAll('add-to-cart-component') || [];
      addToCartComponents.forEach((component) => component.disable?.());

      this.mountPropertyFieldsInForm();

      const formData = new FormData(form);

      // Las propiedades se escriben desde el estado del personalizador y no desde los
      // inputs: si el tema se llevó por delante los campos ocultos, el pedido igual
      // llega con texto, tipografía, color y posición para producción.
      Object.entries(this.getDesignProperties()).forEach(([key, value]) => {
        formData.set(`properties[${key}]`, value);
      });

      formData.delete(PREVIEW_PROPERTY_KEY);
      if (this.previewBlob) {
        formData.append(
          PREVIEW_PROPERTY_KEY,
          this.previewBlob,
          `mifelpa-preview-${Date.now()}.png`
        );
      }

      const sectionIds = [];
      document.querySelectorAll('cart-items-component').forEach((item) => {
        if (item instanceof HTMLElement && item.dataset.sectionId) {
          sectionIds.push(item.dataset.sectionId);
        }
      });
      if (sectionIds.length) {
        formData.set('sections', sectionIds.join(','));
      }

      const cartUrl = window.Theme?.routes?.cart_add_url || '/cart/add.js';

      try {
        const response = await fetch(cartUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        });

        const data = await response.json();

        if (data.status) {
          this.showCartError(form, data.message || 'No se pudo agregar al carrito.');
          return;
        }

        let cart = null;
        try {
          const cartResponse = await fetch('/cart.js');
          cart = await cartResponse.json();
        } catch (_) {
          cart = data;
        }

        const variantId = String(formData.get('id') || '');
        const quantity = Number(formData.get('quantity')) || 1;
        const productId = productFormComponent?.dataset?.productId || '';

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: variantId,
              data: {
                source: 'mifelpa-customizer',
                itemCount: quantity,
                productId,
                sections: data.sections,
              },
            },
          })
        );

        addToCartComponents.forEach((component) => {
          component.enable?.();
          component.animateAddToCart?.();
        });

        this.previewBlob = null;
        if (this.previewFileInput) this.previewFileInput.value = '';
      } catch (error) {
        console.error('MiFelpa: error al agregar al carrito', error);
        this.showCartError(form, 'No se pudo agregar al carrito. Intenta de nuevo.');
      } finally {
        addToCartComponents.forEach((component) => component.enable?.());
      }
    }

    async loadCanvasImage() {
      const src = this.previewImage?.currentSrc || this.previewImage?.src;
      if (!src) throw new Error('Missing preview image');

      if (/^https?:/i.test(src)) {
        const response = await fetch(src, { mode: 'cors', credentials: 'omit' });
        if (!response.ok) throw new Error('Failed to fetch mockup image');
        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        try {
          return await new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => resolve(img);
            img.onerror = () => reject(new Error('Failed to decode mockup image'));
            img.src = objectUrl;
          });
        } finally {
          URL.revokeObjectURL(objectUrl);
        }
      }

      await this.ensureImageLoaded(this.previewImage);
      return this.previewImage;
    }

    ensureImageLoaded(image) {
      if (!image) return Promise.reject(new Error('Missing preview image'));
      if (image.complete && image.naturalWidth) return Promise.resolve(image);
      return new Promise((resolve, reject) => {
        const onLoad = () => {
          image.removeEventListener('load', onLoad);
          image.removeEventListener('error', onError);
          resolve(image);
        };
        const onError = () => {
          image.removeEventListener('load', onLoad);
          image.removeEventListener('error', onError);
          reject(new Error('Preview image failed to load'));
        };
        image.addEventListener('load', onLoad);
        image.addEventListener('error', onError);
      });
    }

    getImageDisplayMetrics() {
      const wrap = this.previewWrap;
      const img = this.previewImage;
      if (!wrap || !img) return null;

      const wrapRect = wrap.getBoundingClientRect();
      const naturalWidth = img.naturalWidth || 1;
      const naturalHeight = img.naturalHeight || 1;
      const displayScale = Math.min(wrapRect.width / naturalWidth, wrapRect.height / naturalHeight);
      const displayWidth = naturalWidth * displayScale;
      const displayHeight = naturalHeight * displayScale;

      return {
        wrapRect,
        naturalWidth,
        naturalHeight,
        displayWidth,
        displayHeight,
        offsetX: (wrapRect.width - displayWidth) / 2,
        offsetY: (wrapRect.height - displayHeight) / 2,
        exportScale: naturalWidth / displayWidth,
      };
    }

    getRenderedGlyphs(element) {
      if (!element) return [];

      const computed = getComputedStyle(element);
      const fontSizePx = parseFloat(computed.fontSize) || this.fontSize;
      const sameLineTolerance = Math.max(2, fontSizePx * 0.4);
      const range = document.createRange();
      const glyphs = [];
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);

      for (let textNode = walker.nextNode(); textNode; textNode = walker.nextNode()) {
        const text = textNode.textContent || '';

        for (let index = 0; index < text.length; index += 1) {
          const char = text[index];
          // Los espacios y los saltos no pintan nada: su posición ya está en el
          // siguiente carácter visible.
          if (/\s/.test(char)) continue;

          range.setStart(textNode, index);
          range.setEnd(textNode, index + 1);
          const rect = range.getBoundingClientRect();
          if (!rect.width && !rect.height) continue;

          const previous = glyphs[glyphs.length - 1];
          if (!rect.width && previous && Math.abs(previous.y - rect.top) <= sameLineTolerance) {
            // Marca combinante (tilde, diéresis): se dibuja junto a su carácter base.
            previous.text += char;
            continue;
          }

          glyphs.push({ text: char, x: rect.left, y: rect.top });
        }
      }

      return glyphs;
    }

    applyCanvasTextTransform(ctx, computed, exportScale) {
      const fontSizePx = parseFloat(computed.fontSize) || this.fontSize;
      const letterSpacing = computed.letterSpacing;
      if (letterSpacing && letterSpacing !== 'normal') {
        const px = letterSpacing.endsWith('em')
          ? parseFloat(letterSpacing) * fontSizePx
          : parseFloat(letterSpacing);
        if (Number.isFinite(px)) ctx.letterSpacing = `${px * exportScale}px`;
      } else {
        ctx.letterSpacing = `${0.02 * fontSizePx * exportScale}px`;
      }
    }

    formatExportLineText(text, computed) {
      const value = String(text || '').replace(/\u00A0/g, ' ');
      switch (computed.textTransform) {
        case 'uppercase':
          return value.toUpperCase();
        case 'lowercase':
          return value.toLowerCase();
        case 'capitalize':
          return value.replace(/\p{L}/gu, (char) => char.toUpperCase());
        default:
          return value;
      }
    }

    buildExportLines(ctx, text, maxWidth) {
      const paragraphs = String(text || '').replace(/\r/g, '').split('\n');
      const lines = [];

      const pushLine = (value) => {
        if (value || lines.length) lines.push(value);
      };

      const breakLongToken = (token) => {
        let chunk = '';
        for (const char of token) {
          const candidate = chunk + char;
          if (!chunk || ctx.measureText(candidate).width <= maxWidth) {
            chunk = candidate;
            continue;
          }
          pushLine(chunk);
          chunk = char;
        }
        return chunk;
      };

      for (const paragraph of paragraphs) {
        if (!paragraph) {
          pushLine('');
          continue;
        }

        const tokens = paragraph.match(/\S+|\s+/g) || [];
        let current = '';

        for (const token of tokens) {
          if (/^\s+$/.test(token)) {
            if (current && !/\s$/.test(current)) current += token.replace(/\s+/g, ' ');
            continue;
          }

          const candidate = current ? `${current}${token}` : token;
          if (ctx.measureText(candidate).width <= maxWidth) {
            current = candidate;
            continue;
          }

          if (current.trim()) {
            pushLine(current.trim());
            current = '';
          }

          if (ctx.measureText(token).width <= maxWidth) {
            current = token;
          } else {
            current = breakLongToken(token);
          }
        }

        if (current.trim()) pushLine(current.trim());
      }

      return lines.length ? lines : [''];
    }

    canvasToBlob(canvas) {
      return new Promise((resolve, reject) => {
        canvas.toBlob(
          (blob) => (blob ? resolve(blob) : reject(new Error('Preview export failed'))),
          'image/png',
          0.92
        );
      });
    }

    async capturePreviewImage() {
      await document.fonts?.ready;
      const canvasImage = await this.loadCanvasImage();
      if (!this.previewText) {
        throw new Error('Preview layout unavailable');
      }

      if (this.isEditing) this.exitEditMode();
      this.updatePreview();
      this.updateTextBoxLayout();
      void this.previewText.offsetHeight;

      const fontFamily = this.selectedFont === 'cooper' ? 'MiFelpa Cooper Five' : 'MiFelpa Helvetica Bold';
      const fontWeight = this.selectedFont === 'cooper' ? '900' : '700';
      const computed = getComputedStyle(this.previewText);
      const fontSizePx = parseFloat(computed.fontSize) || this.fontSize;

      if (document.fonts?.load) {
        await document.fonts.load(`${fontWeight} ${fontSizePx}px "${fontFamily}"`);
      }

      // Prenda y texto se miden en la misma pasada de layout: salir del modo edición
      // cierra el teclado en móvil y desplaza la página, así que medir la imagen antes
      // dejaría el texto corrido respecto del mockup.
      void this.previewText.offsetHeight;
      const metrics = this.getImageDisplayMetrics();
      if (!metrics) throw new Error('Preview layout unavailable');
      const glyphs = this.getRenderedGlyphs(this.previewText);

      const { naturalWidth, naturalHeight, exportScale, wrapRect, offsetX, offsetY } = metrics;
      const imageOriginX = wrapRect.left + offsetX;
      const imageOriginY = wrapRect.top + offsetY;
      const exportFontSize = fontSizePx * exportScale;

      const canvas = document.createElement('canvas');
      canvas.width = naturalWidth;
      canvas.height = naturalHeight;

      const ctx = canvas.getContext('2d');
      if (!ctx) throw new Error('Canvas unavailable');

      ctx.drawImage(canvasImage, 0, 0, naturalWidth, naturalHeight);

      const text = this.text.trim();
      if (!text) return this.canvasToBlob(canvas);

      ctx.fillStyle = this.getTextColorValue();
      ctx.font = `${fontWeight} ${exportFontSize}px "${fontFamily}", sans-serif`;
      ctx.textBaseline = 'top';
      ctx.textAlign = 'left';

      if (glyphs.length) {
        // Cada carácter se dibuja en la posición exacta que el navegador le dio en
        // pantalla. Así el PNG no depende de que el canvas repita el corte de línea,
        // el interletraje ni el justificado del DOM: es la misma maqueta que vio quien compró.
        ctx.letterSpacing = '0px';

        glyphs.forEach((glyph) => {
          const drawText = this.formatExportLineText(glyph.text, computed);
          if (!drawText) return;
          const x = (glyph.x - imageOriginX) * exportScale;
          const y = (glyph.y - imageOriginY) * exportScale;
          ctx.fillText(drawText, x, y);
        });

        return this.canvasToBlob(canvas);
      }

      this.applyCanvasTextTransform(ctx, computed, exportScale);
      const contentWidth = Math.max(this.previewText.getBoundingClientRect().width, 1);
      const fallbackLines = this.buildExportLines(ctx, this.formatExportLineText(text, computed), contentWidth * exportScale);
      const textRect = this.previewText.getBoundingClientRect();
      fallbackLines.forEach((line, index) => {
        if (!line) return;
        const lineHeight = exportFontSize * 1.15;
        const x = (textRect.left - imageOriginX) * exportScale;
        const y = (textRect.top - imageOriginY + index * lineHeight) * exportScale;
        ctx.fillText(line, x, y);
      });

      return this.canvasToBlob(canvas);
    }

    attachPreviewFile(blob) {
      if (!blob) return;
      this.previewBlob = blob;
      if (!this.previewFileInput) return;
      const file = new File([blob], `mifelpa-preview-${Date.now()}.png`, { type: 'image/png' });
      const transfer = new DataTransfer();
      transfer.items.add(file);
      this.previewFileInput.files = transfer.files;
    }

    preloadFonts() {
      if (!document.fonts?.load) return;
      Promise.all([
        document.fonts.load('900 24px "MiFelpa Cooper Five"'),
        document.fonts.load('700 24px "MiFelpa Helvetica Bold"'),
      ]).then(() => this.updatePreview());
    }

    bindEvents() {
      this.addEventListener('click', (event) => {
        const styleBtn = event.target.closest('[data-style-value]');
        if (styleBtn) {
          this.selectedStyle = styleBtn.dataset.styleValue;
          const nextMockup =
            this.findMockup(this.selectedStyle, this.selectedMockup.colorLabel) ||
            this.getMockupsForStyle(this.selectedStyle)[0];
          if (nextMockup) {
            this.selectedMockup = nextMockup;
            if (!this.textColorTouched) this.selectedTextColor = nextMockup.defaultTextColor;
          }
          this.renderStyleOptions();
          this.renderColorOptions();
          if (!this.textColorTouched) this.renderTextColorOptions();
          this.applyMockup(this.selectedMockup);
          this.syncVariant();
          return;
        }

        const colorBtn = event.target.closest('[data-color-id]');
        if (colorBtn) {
          const mockup = this.mockups.find((item) => item.id === colorBtn.dataset.colorId);
          if (mockup) {
            this.selectedMockup = mockup;
            if (!this.textColorTouched) {
              this.selectedTextColor = mockup.defaultTextColor;
              this.renderTextColorOptions();
            }
            this.renderColorOptions();
            this.applyMockup(mockup);
            this.syncVariant();
          }
          return;
        }

        const fontBtn = event.target.closest('[data-font-id]');
        if (fontBtn) {
          this.selectedFont = fontBtn.dataset.fontId;
          this.renderFontOptions();
          this.updatePreview();
          return;
        }

        const textColorBtn = event.target.closest('[data-text-color-id]');
        if (textColorBtn) {
          this.selectedTextColor = textColorBtn.dataset.textColorId;
          this.textColorTouched = true;
          this.renderTextColorOptions();
          this.updatePreview();
          return;
        }

        const alignBtn = event.target.closest('[data-align-id]');
        if (alignBtn) {
          this.selectedAlign = alignBtn.dataset.alignId;
          this.renderAlignOptions();
          this.updatePreview();
        }
      });

      this.centerBtn?.addEventListener('click', () => {
        this.centerTextBox();
        this.updatePreview();
      });

      this.fontSizeInput?.addEventListener('input', () => {
        this.fontSize = Number(this.fontSizeInput.value);
        if (this.fontSizeLabel) this.fontSizeLabel.textContent = `${this.fontSize}px`;
        this.updatePreview();
      });

      this.textInput?.addEventListener('input', () => this.normalizeTextInput());
      this.textInput?.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        if (this.textInput.value.split('\n').length >= MAX_LINES) event.preventDefault();
      });

      this.previewText?.addEventListener('pointerdown', (event) => event.stopPropagation());
      this.previewText?.addEventListener('click', (event) => {
        event.stopPropagation();
        this.enterEditMode();
      });
      this.previewText?.addEventListener('input', () => this.normalizeFromPreview());
      this.previewText?.addEventListener('keydown', (event) => this.onPreviewKeydown(event));
      this.previewText?.addEventListener('paste', (event) => this.onPreviewPaste(event));
      this.previewText?.addEventListener('blur', () => this.exitEditMode());

      this.dragHandle?.addEventListener('pointerdown', (event) => this.startDrag(event));
      this.textBox?.addEventListener('pointerdown', (event) => this.startDrag(event));
      this.resizeHandle?.addEventListener('pointerdown', (event) => this.startResize(event));

      this.mobilePosition?.addEventListener('click', (event) => {
        const nudgeBtn = event.target.closest('[data-nudge]');
        if (!nudgeBtn) return;
        event.preventDefault();
        this.nudgeBox(nudgeBtn.dataset.nudge);
      });

      window.addEventListener('pointermove', (event) => this.onPointerMove(event));
      window.addEventListener('pointerup', (event) => this.endPointerInteraction(event));
      window.addEventListener('pointercancel', (event) => this.endPointerInteraction(event));
      window.addEventListener('resize', () => this.updateTextBoxLayout());
    }

    getPointerCaptureTarget() {
      return this.dragState?.captureTarget || this.textBox;
    }

    startDrag(event) {
      if (event.target.closest('[data-resize-handle]')) return;
      if (event.target.closest('[data-text-content]')) return;
      if (this.isEditing) return;

      const fromHandle = Boolean(event.target.closest('[data-drag-handle]'));
      const fromBox = Boolean(event.target.closest('[data-text-box]'));

      if (this.isMobileInteraction()) {
        if (!fromHandle) return;
      } else if (!fromBox) {
        return;
      }

      event.preventDefault();

      const captureTarget = fromHandle ? this.dragHandle : this.textBox;

      this.dragState = {
        mode: 'drag',
        pointerId: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        startLeft: this.boxLeft,
        startTop: this.boxTop,
        active: false,
        captureTarget,
      };

      captureTarget?.setPointerCapture(event.pointerId);
    }

    startResize(event) {
      event.preventDefault();
      event.stopPropagation();

      this.dragState = {
        mode: 'resize',
        pointerId: event.pointerId,
        startX: event.clientX,
        startLeft: this.boxLeft,
        startWidth: this.boxWidth,
        active: true,
        captureTarget: this.resizeHandle,
      };

      this.resizeHandle?.setPointerCapture(event.pointerId);
      this.textBox?.classList.add('is-resizing');
    }

    onPointerMove(event) {
      if (!this.dragState || event.pointerId !== this.dragState.pointerId) return;
      const safe = this.getSafeRect();
      if (!safe) return;

      const movedX = Math.abs(event.clientX - this.dragState.startX);
      const movedY = Math.abs(event.clientY - (this.dragState.startY ?? event.clientY));

      if (this.dragState.mode === 'drag') {
        if (!this.dragState.active) {
          if (movedX < DRAG_THRESHOLD && movedY < DRAG_THRESHOLD) return;
          this.dragState.active = true;
          this.textBox?.classList.add('is-dragging');
        }

        const deltaX = ((event.clientX - this.dragState.startX) / safe.width) * 100;
        const deltaY = ((event.clientY - this.dragState.startY) / safe.height) * 100;
        this.boxLeft = this.dragState.startLeft + deltaX;
        this.boxTop = this.dragState.startTop + deltaY;
        this.clampBoxPosition();
        this.updateTextBoxLayout();
        this.updateSnapGuide();
        this.updateHiddenFields();
        return;
      }

      if (this.dragState.mode === 'resize') {
        const deltaX = ((event.clientX - this.dragState.startX) / safe.width) * 100;
        this.boxWidth = Math.min(Math.max(this.dragState.startWidth + deltaX, MIN_BOX_WIDTH), MAX_BOX_WIDTH);
        this.clampBoxPosition();
        this.updateTextBoxLayout();
        this.updateHiddenFields();
      }
    }

    endPointerInteraction(event) {
      if (!this.dragState) return;
      if (event?.pointerId != null && event.pointerId !== this.dragState.pointerId) return;

      const { mode, startLeft, startTop, active } = this.dragState;
      const dragDelta = {
        x: Math.abs(this.boxLeft - startLeft),
        y: Math.abs(this.boxTop - startTop),
      };

      this.getPointerCaptureTarget()?.releasePointerCapture?.(this.dragState.pointerId);
      this.textBox?.classList.remove('is-dragging', 'is-resizing');
      this.safeZone?.classList.remove('is-near-center-x', 'is-near-center-y');
      this.dragState = null;

      if (mode === 'drag' && active) this.applySnapToCenter(dragDelta);
      if (mode === 'resize') {
        this.syncBoxWidthFromLayout();
        this.clampBoxPosition();
        this.updateTextBoxLayout();
        this.updateHiddenFields();
      }
    }

    normalizeTextValue(raw) {
      const lines = String(raw || '').replace(/\r/g, '').split('\n').slice(0, MAX_LINES);
      let rebuilt = '';
      let charCount = 0;

      for (let i = 0; i < lines.length; i += 1) {
        const remaining = MAX_CHARS - charCount;
        if (remaining <= 0) break;
        const line = lines[i].slice(0, remaining);
        if (i > 0) rebuilt += '\n';
        rebuilt += line;
        charCount += line.length;
      }

      return rebuilt;
    }

    applyText(text) {
      this.text = text;
      if (this.textInput && this.textInput.value !== text) this.textInput.value = text;
      if (this.previewText && this.isEditing && this.previewText.innerText.replace(/\u00A0/g, ' ') !== text) {
        this.previewText.innerText = text;
        this.focusPreviewTextEnd();
      }
      this.updatePreview();
    }

    enterEditMode() {
      if (!this.previewText || this.isEditing) return;
      this.isEditing = true;
      this.textBox?.classList.add('is-editing');
      this.previewWrap?.classList.add('is-editing-text');

      if (!this.text.trim()) {
        this.previewText.innerText = '';
      }

      this.previewText.classList.remove('is-placeholder');
      this.previewText.focus();
      this.focusPreviewTextEnd();

      if (window.matchMedia('(max-width: 749px)').matches) {
        window.requestAnimationFrame(() => {
          this.previewWrap?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        });
      }
    }

    exitEditMode() {
      if (!this.isEditing) return;
      this.isEditing = false;
      this.textBox?.classList.remove('is-editing');
      this.previewWrap?.classList.remove('is-editing-text');
      if (this.previewText) {
        this.text = this.normalizeTextValue(this.previewText.innerText.replace(/\u00A0/g, ' '));
        if (this.textInput) this.textInput.value = this.text;
      }
      this.updatePreview();
    }

    focusPreviewTextEnd() {
      if (!this.previewText) return;
      const range = document.createRange();
      range.selectNodeContents(this.previewText);
      range.collapse(false);
      const selection = window.getSelection();
      selection?.removeAllRanges();
      selection?.addRange(range);
    }

    onPreviewKeydown(event) {
      if (event.key !== 'Enter') return;
      const lines = this.previewText.innerText.replace(/\u00A0/g, ' ').split('\n');
      if (lines.length >= MAX_LINES) event.preventDefault();
    }

    onPreviewPaste(event) {
      event.preventDefault();
      const paste = event.clipboardData?.getData('text/plain') || '';
      const selection = window.getSelection();
      if (!selection?.rangeCount) return;
      selection.deleteFromDocument();
      selection.getRangeAt(0).insertNode(document.createTextNode(paste));
      selection.collapseToEnd();
      this.normalizeFromPreview();
    }

    normalizeFromPreview() {
      if (!this.previewText) return;
      const rebuilt = this.normalizeTextValue(this.previewText.innerText.replace(/\u00A0/g, ' '));
      this.text = rebuilt;
      if (this.textInput) this.textInput.value = rebuilt;
      if (this.previewText.innerText.replace(/\u00A0/g, ' ') !== rebuilt) {
        this.previewText.innerText = rebuilt;
        if (this.isEditing) this.focusPreviewTextEnd();
      }
      this.updatePreview({ skipPreviewText: true });
    }

    normalizeTextInput() {
      if (!this.textInput) return;
      this.applyText(this.normalizeTextValue(this.textInput.value));
    }

    applyMockup(mockup) {
      const imageSource = mockup.imageUrl || mockup.image;
      if (this.previewImage && imageSource) {
        this.previewImage.crossOrigin = 'anonymous';
        if (/^https?:\/\//.test(imageSource) || imageSource.startsWith('//')) {
          this.previewImage.src = imageSource;
        } else {
          const assetBase = this.config.assetBase || '';
          this.previewImage.src = `${assetBase}${imageSource}`;
        }
        this.previewImage.alt = `${mockup.prenda} ${mockup.colorLabel}`;
      }
      this.updatePreview();
    }

    getTextColorValue() {
      return TEXT_COLORS.find((color) => color.id === this.selectedTextColor)?.value || '#111111';
    }

    getTextColorLabel() {
      return TEXT_COLORS.find((color) => color.id === this.selectedTextColor)?.label || 'Negro';
    }

    getAlignLabel() {
      return ALIGNMENTS.find((align) => align.id === this.selectedAlign)?.label || 'Centrado';
    }

    getDesignProperties() {
      return {
        'Tamaño texto': `${this.fontSize}px`,
        'Posición': `X ${Math.round(this.boxLeft)}% · Y ${Math.round(this.boxTop)}%`,
        'Ancho área': `${Math.round(this.boxWidth)}%`,
        Texto: this.text.trim(),
        'Tipografía': this.selectedFont === 'cooper' ? 'Cooper Five' : 'Helvetica Bold',
        'Color texto': this.getTextColorLabel(),
        'Alineación': this.getAlignLabel(),
        Prenda: this.selectedMockup.prenda,
        Modelo: this.getStyleValue(this.selectedMockup),
        'Color prenda': this.selectedMockup.colorLabel,
      };
    }

    updateHiddenFields() {
      const properties = this.getDesignProperties();
      const fields = [
        [this.hiddenFontSize, 'Tamaño texto'],
        [this.hiddenPosition, 'Posición'],
        [this.hiddenBoxWidth, 'Ancho área'],
        [this.hiddenText, 'Texto'],
        [this.hiddenFont, 'Tipografía'],
        [this.hiddenTextColor, 'Color texto'],
        [this.hiddenAlign, 'Alineación'],
        [this.hiddenPrenda, 'Prenda'],
        [this.hiddenModel, 'Modelo'],
        [this.hiddenColor, 'Color prenda'],
      ];

      fields.forEach(([input, key]) => {
        if (input) input.value = properties[key];
      });
    }

    updatePreview(options = {}) {
      const displayText = this.text.trim() ? this.text : 'TU\nTEXTO';
      const charCount = this.text.replace(/\n/g, '').length;

      if (this.previewText && !this.isEditing && !options.skipPreviewText) {
        this.previewText.textContent = displayText;
        this.previewText.classList.toggle('is-placeholder', !this.text.trim());
      }
      if (this.previewText) {
        this.previewText.dataset.font = this.selectedFont;
        this.previewText.dataset.align = this.selectedAlign;
        this.previewText.style.setProperty('--mf-text-color', this.getTextColorValue());
        this.previewText.style.setProperty('--mf-font-size', `${this.fontSize}px`);
      }

      if (this.fontSizeInput && Number(this.fontSizeInput.value) !== this.fontSize) {
        this.fontSizeInput.value = String(this.fontSize);
      }
      if (this.fontSizeLabel) this.fontSizeLabel.textContent = `${this.fontSize}px`;

      this.updateTextBoxLayout();

      if (this.counter) {
        this.counter.textContent = `${charCount}/${MAX_CHARS}`;
        this.counter.classList.toggle('is-limit', charCount >= MAX_CHARS);
      }

      this.updateHiddenFields();
    }

    syncVariant() {
      const variants = this.config.variants || [];
      const productForm = this.closest('.shopify-section')?.querySelector('[data-type="add-to-cart-form"]');
      const variantInput = productForm?.querySelector('[name="id"]');
      if (!variantInput) return;

      const current = variants.find((variant) => String(variant.id) === String(variantInput.value));
      const tallaIndex = this.optionNames.indexOf('Talla');
      const currentSize = tallaIndex >= 0 ? current?.options?.[tallaIndex] : current?.options?.at(-1);
      const targetOptions = this.buildTargetOptions(currentSize);
      const match =
        variants.find((variant) =>
          (variant.options || []).every((option, index) => option === targetOptions[index])
        ) ||
        variants.find((variant) =>
          (variant.options || []).slice(0, 2).every((option, index) => option === targetOptions[index])
        );

      if (!match) return;

      variantInput.value = match.id;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));

      const variantPicker = productForm.querySelector('variant-picker') || document.querySelector('variant-picker');
      if (variantPicker && typeof variantPicker.selectVariant === 'function') {
        variantPicker.selectVariant(match.id);
      }
    }

    buildTargetOptions(size) {
      if (this.garmentType === 'poleron') {
        return [this.selectedMockup.estilo, this.selectedMockup.colorLabel, size || 'M'];
      }
      return [this.selectedMockup.corte, this.selectedMockup.colorLabel, size || 'M'];
    }
  }

  if (!customElements.get('mifelpa-polo-customizer')) {
    customElements.define('mifelpa-polo-customizer', MiFelpaPoloCustomizer);
  }
})();
